// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__B6rAx","inputWrap":"styles_inputWrap__1ExIs","input":"styles_input__1d0CD"};